import { Box } from '@mui/material';
import * as React from 'react';
import HeaderSection from '../components/common/header/Header';
import PrivacyPolicyDescription from '../components/privacypolicy/PrivacyPolicyDescription';

function PrivacyPolicy(){
  React.useEffect(() => { document.title = "Privacy Policy | Meesha"; }, []);
    return (
        <Box>
            <HeaderSection showNav={true}/>
            <PrivacyPolicyDescription />            
        </Box>
    )
}

export default PrivacyPolicy;